import { render, staticRenderFns } from "./consumableBorrowChlid.vue?vue&type=template&id=87d63daa&scoped=true"
import script from "./consumableBorrowChlid.vue?vue&type=script&lang=js"
export * from "./consumableBorrowChlid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d63daa",
  null
  
)

export default component.exports